import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Sparkles } from 'lucide-react';

export function ReferralCTA() {
  useLanguage();
  const handleContactClick = () => {
    window.open('https://api.whatsapp.com/send/?phone=557199407090&text=Ol%C3%A1%2C+quero+me+cadastrar+no+Programa+de+Parceiros+Host+VSL+e+come%C3%A7ar+a+indicar+clientes.&type=phone_number&app_absent=0', '_blank');
  };

  return (
    <section className="py-8">
      <Card className="border-primary/20 bg-gradient-to-br from-primary/5 to-primary/10">
        <CardContent className="text-center space-y-6 py-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 mb-4">
            <Sparkles className="w-8 h-8 text-primary" />
          </div>
          
          <div className="space-y-4">
            <h3 className="text-2xl lg:text-3xl font-bold text-foreground">
              {translateInterfaceText("Pronto para Começar a Ganhar?")}</h3>
            
            <p className="text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
              {translateInterfaceText("Entre em contato com nosso time e torne-se um parceiro Host VSL hoje mesmo!")}</p>
          </div>
          
          <Button 
            size="lg" 
            className="mt-6"
            onClick={handleContactClick}
          >
            {translateInterfaceText("Quero Ser Parceiro Host VSL")}</Button>
          
          <p className="text-sm text-muted-foreground">
            {translateInterfaceText("Ou envie um WhatsApp para:")}{" "}<a href="https://api.whatsapp.com/send/?phone=557199407090" className="text-primary hover:underline font-semibold" target="_blank" rel="noopener noreferrer">+55 71 99407-0090</a>
          </p>
        </CardContent>
      </Card>
    </section>
  );
}
